import React from "react";
import styles from "./ScrollToTopButton.module.css";
import arrowUp from "../../assets/images/arrow_up.svg"

const SCROLL_THRESHOLD = 1500

const scrollToTop = (element) => {
    element.scrollTo({
        top: 0,
        behavior: "smooth",
    });
  }

const ScrollToTopButton = ({modalRef}) => {
  let modalDialog = modalRef ? modalRef.parentElement.parentElement.parentElement : null
  const [visible, setVisible] = React.useState(false);
  const onScroll = () => {
    const scrollDocument = modalDialog ? modalDialog : document.documentElement
    setVisible(scrollDocument.scrollTop > SCROLL_THRESHOLD)
  };
  React.useEffect(() => {
    const scrollElement = modalDialog ? modalDialog: document
    if (scrollElement) scrollElement.addEventListener("scroll", onScroll);
    return () => scrollElement.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {visible && (
        <button
          className={styles.ScrollToTopButton}
          style={modalDialog ? {marginRight: '15px', marginBottom: '15px'} : null}
          onClick={() => scrollToTop(modalDialog || document.documentElement)}
        >
          <img src={arrowUp} alt="Back to top" />
        </button>
      )}
    </>
  );
}

export default ScrollToTopButton;